import React, { useMemo } from "react";
import { Group } from "react-konva";
import { EPDPlanTrainUnit } from "./EPDPlanTrainUnit";
import { Orientation } from "@opstel/query/v2/models/action";
import { ShuntingUnit } from "@opstel/query/models/shuntingUnit";
import { DirectionalList } from "@opstel/query/models/types/directionalList";
import { zip } from "@shared/common/utils/zip";
import { Point } from "@opstel/geo/Point";
import { SCALING_VECTOR } from "../core/layoutConstants";

type ShuntingUnitProps = {
  readonly planTrainUnitPaths: DirectionalList<Point[]>;
  readonly orientation: Orientation;
  readonly trackLineWidth: number;
  readonly shuntingUnit: ShuntingUnit;
};

export function EPDShuntingUnit({
  planTrainUnitPaths,
  trackLineWidth,
  shuntingUnit,
  orientation,
}: ShuntingUnitProps): React.JSX.Element {
  const ptusFromSourceToTarget = shuntingUnit.planTrainUnits.fromSourceToTarget(orientation);
  const planTrainUnitsWithPath = useMemo(
    () => zip(ptusFromSourceToTarget, planTrainUnitPaths.fromSourceToTarget),
    [planTrainUnitPaths, ptusFromSourceToTarget],
  );
  return (
    <Group>
      {planTrainUnitsWithPath.map(([ptu, ptuPath]) => {
        return (
          <EPDPlanTrainUnit
            key={ptu.guid}
            planTrainUnit={ptu}
            points={ptuPath.map((point) => point.scale(SCALING_VECTOR))}
            trackLineWidth={trackLineWidth}
          />
        );
      })}
    </Group>
  );
}
